import React from 'react'

export const LargeYSpace = () => {
  return <div style={{height: '30px'}} />
}
export const SmallYSpace = () => {
  return <div style={{height: '10px'}} />
}
export const SmallXSpace = () => {
  return <div style={{width: '10px'}} />
}
